import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-releases-approvers.common.no-permission-error.title',
		defaultMessage: "Can't add approvers",
		description: 'Title of the add approvers dialog in disabled state',
	},
	description: {
		id: 'software-releases-approvers.common.no-permission-error.description',
		defaultMessage: "You don't have permission to add approvers to this version.",
		description: 'Description of the add approvers dialog in disabled state',
	},
});
